/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIBlankEnum {
    empty = ''
}


export function instanceOfAPIBlankEnum(value: any): boolean {
    for (const key in APIBlankEnum) {
        if (Object.prototype.hasOwnProperty.call(APIBlankEnum, key)) {
            if (APIBlankEnum[key as keyof typeof APIBlankEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIBlankEnumFromJSON(json: any): APIBlankEnum {
    return APIBlankEnumFromJSONTyped(json, false);
}

export function APIBlankEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBlankEnum {
    return json as APIBlankEnum;
}

export function APIBlankEnumToJSON(value?: APIBlankEnum | null): any {
    return value as any;
}

